<div class="row">
  <div class="col-12 mb-5 col-sm-6">
    <h1>Platform / Select</h1>
  </div>
</div>

<div class="form">
  <form [formGroup]="form">
    <div class="row">
      <div class="col-6 ui-platform-form-control">
        <ui-platform-select
          formControlName="selectTwo"
          [label]="'Select person'"
          [options]="options"
          [placeholder]="'Pick name'">
        </ui-platform-select>
      </div>
    </div>
    <div class="row">
      <div class="col-6 ui-platform-form-control">
        <ui-platform-select
          formControlName="selectThree"
          [label]="'Select person'"
          [options]="options"
          [placeholder]="'Pick name'">
        </ui-platform-select>
      </div>
    </div>
    <div class="row">
      <div class="col-6 ui-platform-form-control">
        <ui-platform-select
          formControlName="selectOne"
          [label]="'Select brand'"
          [options]="options"
          [placeholder]="'Pick name'">
        </ui-platform-select>
        <div
          class="ui-platform-form-control-error"
          *ngIf="selectOneError">
          Required
        </div>
      </div>
    </div>
  </form>
</div>

<div class="row">
  <div class="col-12">
    <h2>Code</h2>
    <p>Declare module:</p>
    <pre>{{ import }}</pre>
    <p>Use component in a template:</p>
    <pre>{{ usage }}</pre>
    <p><i>Note: display of errors in not part of a component, implemented as ui-platform-form-control classes</i></p>
  </div>
</div>
